import { GetStoresServiceQueryParamType } from '@/server/services/vendor/stores/models';

export const normalizeStoreQuery = (query: GetStoresServiceQueryParamType) => {
    const { lat, lng, servingCategoryIds, customerCityId, freeShipping, ...filters } = query;
    const hasLocation = typeof lat === 'number' && Number.isFinite(lat) && typeof lng === 'number' && Number.isFinite(lng);
    const categories = servingCategoryIds
        ?.flatMap((id) => String(id).split(','))
        .map((id) => id.trim())
        .filter(Boolean);

    return Object.fromEntries(
        Object.entries({
            ...filters,
            ...(Array.isArray(customerCityId) ? (customerCityId.length ? { customerCityId: [...new Set(customerCityId)] } : {}) : { customerCityId }),
            ...(hasLocation ? { lat, lng } : {}),
            ...(categories?.length ? { servingCategoryIds: [...new Set(categories)] } : {}),
            ...(freeShipping === true && (!filters.fulfillmentType || filters.fulfillmentType === 'SHIPPING') ? { freeShipping: true } : {})
        }).filter(([, value]) => value !== undefined && value !== null)
    );
};
